// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_EVENT, EDIT_EVENT, EVENT, GET_EVENT, DELETE_EVENT } from '../../../../common/constant'

export const actionEvent = createAsyncThunk('appEvent/actionEvent', async (params, thunkAPI) => {
    return await post(EVENT, params, thunkAPI)
})

export const actionAddEvent = createAsyncThunk('appEvent/actionAddEvent', async (params, thunkAPI) => {
    return await put(ADD_EVENT, params, thunkAPI)
})

export const actionGetEvent = createAsyncThunk('appEvent/actionGetEvent', async (params, thunkAPI) => {
    return await post(GET_EVENT, params, thunkAPI)
})

export const actionEditEvent = createAsyncThunk('appEvent/actionEditEvent', async (params, thunkAPI) => {
    return await post(EDIT_EVENT, params, thunkAPI)
})

export const actionDeleteEvent = createAsyncThunk('appEvent/actionDeleteEvent', async (params, thunkAPI) => {
    return await post(DELETE_EVENT, params, thunkAPI)
})

export const appEventSlice = createSlice({
    name: 'appEvent',
    initialState: {
        //list
        loading: false,
        event: null,

        //add
        loadingAdd: false,
        addEvent: null,

        //get
        loadingGet: false,
        getEvent: null,

        //edit
        loadingEdit: false,
        editEvent: null,

        //delete
        loadingDelete: false,
        deleteEvent: null

    },
    reducers: {
        //reset or delete Add Insurance Event store data
        resetEventResponse: (state) => {
            state.event = null
        },
        resetAddEventResponse: (state) => {
            state.addEvent = null
        },
        resetGetEventResponse: (state) => {
            state.getEvent = null
        },
        resetEditEventResponse: (state) => {
            state.editEvent = null
        },
        resetDeleteEventResponse: (state) => {
            state.deleteEvent = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionEvent.pending, (state) => {
                state.loading = true
            })
            .addCase(actionEvent.fulfilled, (state, action) => {
                state.loading = false
                state.event = action.payload
            })
            .addCase(actionEvent.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddEvent.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddEvent.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addEvent = action.payload
            })
            .addCase(actionAddEvent.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetEvent.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetEvent.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getEvent = action.payload
            })
            .addCase(actionGetEvent.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditEvent.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditEvent.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editEvent = action.payload
            })
            .addCase(actionEditEvent.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteEvent.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteEvent.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteEvent = action.payload
            })
            .addCase(actionDeleteEvent.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetEventResponse, resetAddEventResponse, resetGetEventResponse, resetEditEventResponse, resetDeleteEventResponse } = appEventSlice.actions

export default appEventSlice.reducer